import React, { useState, useEffect, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, FormControl, InputLabel, Select, MenuItem, Autocomplete, TextField, Box, Grid, Typography } from '@mui/material';
import FormBuilder from "../../components/formBuilder/FormBuilder";
import "./RateCardConfigForm.scss";
import { useDispatch, useSelector } from 'react-redux';
import rateService from "services/rateService";
import { getCar } from 'redux/actions/UserCar';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PackageConfig from "./PackageConfig";
import {
  getCompanyDuty,
  getCompanyLocation,
  getSubCity,
  clearSubCity
} from "redux/actions/UserRateCard";

import {
  getCompanyCity,
  getCompanyService,
} from "redux/actions/ReservationAction";
import { rateCardFiltersEnum } from "utils/enumObj";


const getRateTypeByRideType = (rideType) => {
  if (rideType === "Rental" || rideType === "Outstation") {
    return "package";
  }
  return "flat_per_km";
};

const transformDutyTypeOptions = (dutyTypes) => {
  if (!dutyTypes) return [];
  return dutyTypes.map(duty => ({
    value: duty.name,
    label: duty.name,
    tripType: duty.tripType
  }));
};

export default function CityConfigForm({companyContractId, isConfigureMode = false}) {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state || {};

  // Redux selectors
  const carData = useSelector((state) => state?.userCar?.userCar?.data?.body);
  const dutyTypeData = useSelector(
      (state) => state?.userDutyType?.dutyTypeList?.data
  );
  const cityData = useSelector(
      (state) => state?.userServiceCity?.userServiceCity?.data
  );

  
  const selectedCityData = useSelector(
    (state) =>state?.getCompanyCity?.companyCity?.data
  );
  
  const selectedDutyTypeData = useSelector(
      (state) => state?.getCompanyService?.companyService?.data
    );
    const selectedCarData = useSelector((state) => state?.userCar?.userCar?.data);
 
  const companyProfile = useSelector(
    (state) => state?.userCompanyDetails?.companyDetails
  );

  // Form state
  const [formData, setFormData] = useState({
    locationId: null,
    rideType: "",
    carType: "",
    rateType: "km",
    baseRate: "",
    surCharge: "",
    platformCharge: "",
    waitingTime: "",
    bufferTime: "",
    extraKmCharge: "",
    graceKm: "",
    extraTimeCharge: "",
    graceTime: "",
    kmCharge: "",
    rateConfig: {
      base_rate_per_km: ""
    },
    peakHours: []
  });

  // Component state
  const [rateType, setRateType] = useState(state.rateType || "km");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [rateCardId, setRateCardId] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const [hasExistingConfig, setHasExistingConfig] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [selectedDutyType, setSelectedDutyType] = useState('');
  const [selectedCarType, setSelectedCarType] = useState('');

  // Filter state (from CompanyProfileRateCard)
  const [subCityStatus, setSubCityStatus] = useState(3);
  const [fuelBase, setFuelBase] = useState("102");

  // Prepare options from Redux state
  const cityOptions = (selectedCityData?.length > 0
    ? selectedCityData.map((val) => ({ name: val?.name, id: val?.id }))
    : []);


  const dutyOptions = (selectedDutyTypeData?.length > 0
    ? selectedDutyTypeData?.map((val) => ({ id: val.tripType, name: val.name }))
    : []);
  const dutyTypeOptions = dutyOptions;
  
    const carOptions = 
    (selectedCarData?.length > 0
      ? selectedCarData?.map((val) => ({ id: val?.id, name: val?.carType }))
      : []);

  const contractId = companyContractId ? companyContractId : 
    companyProfile?.Contracts?.[0]?.CompanyContracts?.ContractId;

    const [filterValues, setFilterValues] = useState({
      cityType: cityOptions?.length > 0 ? cityOptions?.[0] : "",
      dutyType:  "",
      carType: "",
      subCityType: {id: "", name: ""},
    });


   useEffect(() => {
      if (companyProfile?.Contracts?.length) {
        dispatch(getCompanyCity({contractId}));
      }
    }, [companyProfile]);
  
    useEffect(() => {
      if (!filterValues?.dutyType?.id && cityOptions?.[0]?.id) {
        setFilterValues({ ...filterValues, cityType: cityOptions?.[0] });
        setSelectedLocation(cityOptions?.[0]?.id);
        dispatch(
          getCompanyService({
            contractId: contractId,
            location: filterValues?.cityType?.id || cityOptions?.[0]?.id,
          })
        );
      }
    }, [cityOptions?.[0]?.id]);
  
    useEffect(() => {
      if (!filterValues?.dutyType?.id && dutyOptions?.[0]?.id) {
        setFilterValues({ ...filterValues, dutyType: dutyOptions?.[0] });
        setSelectedDutyType(dutyOptions?.[0]?.id);

        const dutyTypeName = dutyOptions?.[0]?.name;

        let newRateType = (dutyTypeName.startsWith("Ride") || dutyTypeName.startsWith("Airport")) ? "km" : "package";
          setRateType(newRateType);
          setFormData(prev => ({
            ...prev,
            rideType: dutyTypeName || "",
            rateType: newRateType,
          }));
  
        if(dutyOptions?.[0]?.id === 4) {
          dispatch(getSubCity(cityOptions?.[0]?.id));
          setSubCityStatus(0);
        }

        if(!isConfigureMode) {
          dispatch(
            getCar({
              contractId: contractId,
              type: dutyOptions?.[0]?.id,
              location: cityOptions?.[0]?.id,
            })
          );
        }
       
      }
    }, [dutyOptions?.[0]?.id]);

    useEffect(() => {
        if (carOptions?.[0]?.id) {
          setFilterValues({ ...filterValues, carType: carOptions?.[0] });
          setSelectedCarType(carOptions?.[0]?.id);
        }
      }, [carOptions?.[0]?.id]);

    useEffect(() => {
      // Fetch initial rate card configuration when component mounts
      if (selectedLocation && selectedDutyType && selectedCarType && contractId) {
        fetchRateCardConfig();
      }
    }, [selectedLocation, selectedDutyType, selectedCarType, contractId]);

   const handleChange = (newValue, name) => {  
      const filterValuesData = filterValues;
      filterValuesData[name] = newValue;
      setFilterValues(filterValues);
      if (name === rateCardFiltersEnum?.cityType) {

        if(!isConfigureMode) {
          dispatch(
            getCompanyService({
              contractId: contractId,
              location: newValue?.id,
            }, "rateCard", setFilterValues, filterValuesData, setSubCityStatus)
          );
          dispatch(clearSubCity());
    
          if(filterValues?.dutyType?.id === 4) {
            dispatch(getSubCity(newValue?.id,  "rateCard", setFilterValues, filterValuesData))
          }
        }
        setFilterValues({...filterValues, subCityType: {id: "", name: ""}});
        setSelectedLocation(newValue?.id);
    
      } else if (name === rateCardFiltersEnum?.dutyType) {
  
          setSubCityStatus(newValue?.id === 4 ? 0 :3);

          const dutyTypeName = dutyOptions.find(option => option.id === newValue?.id)?.name;
          let newRateType = (dutyTypeName.startsWith("Ride") || dutyTypeName.startsWith("Airport")) ? "km" : "package";
          setRateType(newRateType);
          setFormData(prev => ({
            ...prev,
            rideType: dutyTypeName || "",
            rateType: newRateType,
          }));

          setSelectedDutyType(newValue?.id);
        
        if(!isConfigureMode) {
          dispatch(
            getCar({
              contractId: contractId,
              type: newValue?.id,
              location: filterValues?.cityType?.id || cityOptions?.[0]?.id,
            })
          );
        }
        } else if (name === rateCardFiltersEnum?.carType) {
        const data = {
          carType: newValue?.id,
          type: filterValuesData?.dutyType?.id,
          baseFuelPrice: parseFloat(fuelBase),
          location: filterValuesData?.cityType?.id,
          contractId: contractId,
          subCity: filterValuesData?.subCityType?.id || ""
        };
        setSelectedCarType(newValue?.id);
  
      }
    };


    async function fetchRateCardConfig() {
      // Get current filter values including the new change
      const currentFilters = {
        location: selectedLocation,
        rideType: dutyOptions.find(option => option.id === selectedDutyType)?.name,
        carType: selectedCarType,
        contractId
      };
      // Call getRateCard if at least one filter has a value
      if (currentFilters.location || currentFilters.rideType || currentFilters.carType) {
        setIsLoading(true);
        try {
          const currentRateType = getRateTypeByRideType(currentFilters.rideType);
          const result = await rateService.getRateCard(
            currentFilters.location || '',
            currentFilters.rideType || '',
            currentFilters.carType || '',
            currentFilters.contractId || '',
            dutyTypeOptions,
            currentRateType
          );
  
          if (result.success) {
            setHasExistingConfig(result.data.hasExistingConfig);
            
  
            if (result.data.hasExistingConfig && result.data.formattedData) {
              // Update form with existing configuration
              setFormData(result.data.formattedData);
              setRateCardId(result.data.data[0].id);
            } else {
              // Reset form but keep current filter values
              setFormData(prev => ({
                ...prev,
                locationId: currentFilters.location || prev.locationId,
                rideType: currentFilters.rideType || prev.rideType,
                carType: currentFilters.carType || prev.carType,
                // Use the current ride type to determine rate type if it's a ride type change
                rateType: ((currentFilters.rideType.startsWith("Ride") || currentFilters.rideType.startsWith("Airport")) ? "km" : "package"),
                baseRate: '',
                surCharge: '',
                platformCharge: '',
                waitingTime: '',
                bufferTime: '',
                extraKmCharge: '',
                graceKm: '',
                extraTimeCharge: '',
                graceTime: '',
                kmCharge: "",
                rateConfig: {
                  base_rate_per_km: "",
                },
              }));
              setRateCardId(null);
            }
            setHasChanges(false);
          }
        } catch (error) {
          console.error('Error fetching rate card:', error);
        } finally {
          setIsLoading(false);
        }
      } else {
        // Reset form data if no filters are selected
        setFormData(prev => ({
          ...prev,
          locationId: '',
          rideType: '',
          carType: '',
          rateType: '',
          baseRate: '',
          surCharge: '',
          platformCharge: '',
          waitingTime: '',
          bufferTime: '',
          extraKmCharge: '',
          graceKm: '',
          extraTimeCharge: '',
          graceTime: '',
          kmCharge: "",
          rateConfig: {
            base_rate_per_km: "",
          },
        }));
        setHasExistingConfig(false);
        setRateCardId(null);
      }
    }

  // Handle form data changes
  const handleFormChange = useCallback((updatedData) => {
    setFormData(prev => {
      const hasActualChanges = Object.keys(updatedData).some(key => {
        if (key === 'packages') {
          const prevPackages = prev[key] || [];
          const updatedPackages = updatedData[key] || [];
          return JSON.stringify(prevPackages) !== JSON.stringify(updatedPackages);
        }
        return String(updatedData[key]) !== String(prev[key]);
      });

      if (hasActualChanges) {
        setHasChanges(true);
      }

      return { ...prev, ...updatedData };
    });
  }, []);

  // Get rate type options based on selected ride type
  const getRateTypeOptions = useCallback(() => {
    const selectedRideType = filterValues.dutyType?.name || formData.rideType;

    if (selectedRideType?.startsWith("Ride") || selectedRideType?.startsWith("Airport")) {
      return [{ value: "km", label: "/km", disabled: false }];
    }

    if (selectedRideType === "Rental" || selectedRideType === "Outstation") {
      return [{ value: "package", label: "Package", disabled: false }];
    }

    return [
      { value: "km", label: "/km", disabled: true },
      { value: "package", label: "Package", disabled: true }
    ];
  }, [filterValues.dutyType?.name, formData.rideType]);

  // Form configuration
  const getFormConfig = () => ({
    title: "Configure Rates",
    formField: [
      {
        title: "Basic Configuration",
        formFields: [
          {
            name: "rateType",
            // label: "Rate Type",
            inputType: "select",
            options: getRateTypeOptions(),
            value: formData.rateType, // Set current value
            validation: { required: "Rate Type is required" }
          },
           {
        name: "baseRate",
        label: "Base Rate",
        inputType: "number",
        prefix: "₹",
        validation: { 
          required: "Base Rate is required",
          min: { value: 1, message: "Must be greater than 0" }
        }
      },
          // Add Rate Configuration section
        // {
        //   name: "kmCharge",
        //   label: "Rate per KM",
        //   inputType: "number",
        //   prefix: "₹",
        //   validation: { 
        //     required: "Rate per KM is required",
        //     min: { value: 0, message: "Must be greater than 0" }
        //   },
        //   // Only show for km-based rate types
        //   visible: formData.rateType === 'km'
        // },
        {
          name: "surCharge", // Changed from "surcharge" to "surCharge"
          label: "Surcharge",
          inputType: "number",
          prefix: "₹",
          validation: { 
            
            min: { value: 1, message: "Must be greater than 0" }
          }
        },
          {
        name: "platformCharge",
        label: "Platform Charge",
        inputType: "number",
        prefix: "₹",
        validation: { 
          
          min: { value: 1, message: "Must be greater than 0" }
        }
      }
        ]
      }
    ],
    selectedRideType: filterValues.dutyType,
    rateType
  });

  // Save form data
  const handleSaveFormData = useCallback(async () => {
    const locationToUse = formData.locationId || filterValues.cityType?.id;

    if (!locationToUse) {
      toast.warning('Please select a location');
      return;
    }

    setIsSaving(true);
    try {
      const result = await rateService.createRateCard(formData, locationToUse, contractId, dutyTypeOptions);
      const newRateCardId = result?.data?.created?.[0]?.id;

      if (result.success) {
        setHasChanges(false);
        setHasExistingConfig(true);
        setRateCardId(newRateCardId);
        toast.success('Rate card saved successfully');
      }
    } catch (error) {
      console.error('Error saving rate card:', error);
      toast.error('Error saving rate card');
    } finally {
      setIsSaving(false);
    }
  }, [formData, filterValues.cityType?.id, dutyTypeOptions]);

  // Update form data
  const handleUpdateFormData = useCallback(async () => {
    if (!rateCardId) {
      return;
    }

    setIsUpdating(true);
    try {
      const result = await rateService.updateRateCard(rateCardId, formData);
      if (result.success) {
        setHasChanges(false);
        toast.success('Rate card updated successfully');
      }
    } catch (error) {
      console.error('Error updating rate card:', error);
      toast.error('Error updating rate card');
    } finally {
      setIsUpdating(false);
    }
  }, [rateCardId, formData]);

  const hasInvalidValues = () => {
    const requiredFields = ['baseRate'];

    if (formData.rateType === 'km') {
      requiredFields.push('kmCharge');
    }

    return requiredFields.some(field => {
      const value = parseFloat(formData[field]);
      return isNaN(value) || value <= 0;
    });
  };


  const selectSx = {
    height: '40px',
    '& .MuiSelect-select': {
      padding: '8px 14px',
    }
  };

  return (
    <>
      <div className="city-config-form">
        <div style={{
          display: 'flex',
          gap: '20px',
          marginBottom: '20px',
          alignItems: 'flex-start'
        }}>
          <Select
            style={{ flex: 0.3 }}
            size="small"
            sx={selectSx}
            value={selectedLocation ?? ''}
            onChange={(e) => handleChange({id: e.target.value}, 'cityType')}
          >
            {cityOptions.map(option => (
              <MenuItem key={option.id} value={option.id}>
                {option.name}
              </MenuItem>
            ))}
          </Select>

          <Select
            style={{ flex: 0.3 }}
            size="small"
            sx={selectSx}
            value={selectedDutyType ?? ''}
            onChange={(e) => handleChange({id: e.target.value},'dutyType')}
          >
            {dutyOptions.map(option => (
              <MenuItem key={option.id} value={option.id}>
                {option.name}
              </MenuItem>
            ))}
          </Select>

          <Select
            style={{ flex: 0.3 }}
            size="small"
            sx={selectSx}
            value={selectedCarType ?? ''}
            onChange={(e) => handleChange({id: e.target.value}, 'carType')}
          >
            {carOptions.map(option => (
              <MenuItem key={option.id} value={option.id}>
                {option.name}
              </MenuItem>
            ))}
          </Select>
        </div>

        {isLoading ? (
          <div>Loading rate card data...</div>
        ) : (
          <>
            {formData.rateType === 'package' ? (
              <PackageConfig
                initialData={formData}
                onChange={handleFormChange}
                selectedLocation={selectedLocation}
                selectedRideType={filterValues.dutyType?.name || formData.rideType}
                selectedCarType={selectedCarType}
                contractId={contractId}
                rateCardId={rateCardId}
                isUpdate={hasExistingConfig}
                isConfigureMode={isConfigureMode}
              />
            ) : (
              <>
                <FormBuilder
                  formConfig={getFormConfig()}
                  values={formData}
                  onChange={handleFormChange}
                  hideSubmitButton={true}
                />

                {isConfigureMode && <div className="save-button-container" style={{ display: 'flex', gap: '10px' }}>
                  {hasExistingConfig ? (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleUpdateFormData}
                      disabled={isLoading || isUpdating || !hasChanges || hasInvalidValues()}
                      sx={{ textTransform: "none" }}
                    >
                      {isUpdating ? 'Updating...' : 'Update Configuration'}
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleSaveFormData}
                      disabled={isLoading || isSaving || !hasChanges || hasInvalidValues()}
                      sx={{ textTransform: "none" }}
                    >
                      {isSaving ? 'Saving...' : 'Save Configuration'}
                    </Button>
                  )}
                </div>}
              </>
            )}
            {/* <PeakHourConfig 
      locationId={selectedLocation}
      carType={selectedCarType}
      rideType={selectedRideType}
      companyId={""}
      initialPeakHours={peakHours}
    /> */}
          </>
        )}

        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </>
  );
}

